<template>
  <div id="app">
    <div v-if="screenWidth < 1200">

      <router-view ></router-view>
      <Footer/>
    </div>
    <div class="iframe" v-else>
      <iframe :src="baseURL" style="width: 650px; height: 100vh; margin: auto; text-align: center;"></iframe>
    </div>


  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      screenWidth:0,
      status:0,
      baseURL: window.location.origin,
    };
  },
  watch: {
    screenWidth: function(t) {
      this.screenWidth = t;
      /*t <= 120 && (this.screenWidth = t)
      console.log(t);*/
    }
  },
  methods: {

    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    },
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        document.title = res.data.name;
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  mounted() {
    this.screenWidth = document.body.clientWidth,
        window.onresize = () => (() => {
              this.screenWidth = document.body.clientWidth
            }
        )();
  },
  created(){
      this.getBaseInfo();
  }
}
</script>

<style>

</style>
